import { VendorProfile } from "@/graphql/fragments.ts";
import { gql } from "@apollo/client";

export const VENDORS_COMPACT_QUERY = gql`
  query VendorsCompact {
    vendorsWithoutPagination {
      id
      profile {
        ...VendorProfile
      }
    }
  }
  ${VendorProfile}
`;

export const UPDATE_CLIENT_OFFICE_ALERT_RULES_MUTATION = gql`
  mutation UpdateClientOfficeAlertRules(
    $isMaxPerAlertEnabled: Boolean!
    $percentage: Int
    $isPreferredVendorAlertEnabled: Boolean!
    $preferredVendorIds: [SmartID!]
  ) {
    updateClientOfficeAlertRules(
      isMaxPerAlertEnabled: $isMaxPerAlertEnabled
      percentage: $percentage
      isPreferredVendorAlertEnabled: $isPreferredVendorAlertEnabled
      preferredVendorIds: $preferredVendorIds
    ) {
      success
      message
    }
  }
`;

export const DELETE_INACTIVE_USER_MUTATION = gql`
  mutation DeleteInactiveUser($userId: SmartID!) {
    deleteInactiveUser(userId: $userId) {
      success
      message
    }
  }
`;

export const RESEND_INVITATION_MUTATION = gql`
  mutation ResendInvitation($userId: SmartID!) {
    resendInvitation(userId: $userId) {
      success
      message
    }
  }
`;

export const REVOKE_INVITATION_MUTATION = gql`
  mutation RevokeInvitation($userId: SmartID!) {
    revokeInvitation(userId: $userId) {
      success
      message
    }
  }
`;

export const INVITE_USERS_MUTATION = gql`
  mutation InviteUsers(
    $emails: [String!]!
    $role: UserRoleEnum!
    $primaryOfficeId: SmartID
    $additionalOfficeIds: [SmartID!]
  ) {
    inviteUsers(
      emails: $emails
      role: $role
      primaryOfficeId: $primaryOfficeId
      additionalOfficeIds: $additionalOfficeIds
    ) {
      success
      message
    }
  }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser(
    $userId: SmartID!
    $isMaxPerAlertEnabled: Boolean!
    $isActive: Boolean!
    $role: UserRoleEnum!
    $primaryOfficeId: SmartID
    $additionalOfficeIds: [SmartID!]
  ) {
    updateUser(
      userId: $userId
      isMaxPerAlertEnabled: $isMaxPerAlertEnabled
      isActive: $isActive
      role: $role
      primaryOfficeId: $primaryOfficeId
      additionalOfficeIds: $additionalOfficeIds
    ) {
      success
      message
    }
  }
`;
